import { Component, Element, h, Host, Listen } from "@stencil/core";
import { CheckboxRule } from "./interfaces/checkbox-rule";

const baseClass = "ux-checkbox-rules";
const requireAttr = "data-ux-checkbox-rules-require";

@Component({
    tag: "ux-checkbox-rules",
    shadow: false
})
export class CheckboxRules {
    @Element() element!: HTMLUxCheckboxRulesElement;

    private checkboxRules: CheckboxRule[] = [];

    private getCheckboxRuleByName = (name: string): CheckboxRule => {
        return this.checkboxRules.filter((rule) => rule.name === name)[0];
    };

    private getCheckboxByName = (name: string): HTMLUxCheckboxElement => {
        return this.element.querySelector(`ux-checkbox[name=${name}]`) as HTMLUxCheckboxElement;
    };

    @Listen("uxCheckboxChange")
    handleCheckboxChanges(e: CustomEvent) {
        // Does not work with nested required rules
        const checkbox = e.target as HTMLUxCheckboxElement;
        const checkboxRule = this.getCheckboxRuleByName(checkbox.name);
        const otherCheckboxRules = this.checkboxRules.filter((rule) => rule !== checkboxRule);
        checkboxRule.checked = checkbox.checked;
        if (checkbox.checked) {
            const activated: string[] = [];
            checkboxRule.required.forEach((checkboxName) => {
                const requiredCheckboxRule = this.getCheckboxRuleByName(checkboxName);
                const requiredCheckbox = this.getCheckboxByName(checkboxName);
                if (!requiredCheckbox.checked) {
                    activated.push(checkboxName);
                }
                requiredCheckboxRule.checked = true;
                requiredCheckbox.checked = true;
                checkboxRule.activated = activated;
            });
        } else {
            checkboxRule.activated.forEach((checkboxName) => {
                const activatedCheckbox = this.getCheckboxByName(checkboxName);
                activatedCheckbox.checked = false;
            });
            checkboxRule.activated = [];

            // Check if current checkbox is required on other rules
            otherCheckboxRules.forEach((otherRule) => {
                if (otherRule.required.includes(checkbox.name)) {
                    otherRule.activated.forEach((checkboxName) => {
                        const activatedCheckbox = this.getCheckboxByName(checkboxName);
                        activatedCheckbox.checked = false;
                    });
                    otherRule.activated = [];
                    otherRule.checked = false;
                    this.getCheckboxByName(otherRule.name).checked = false;
                }
            });
        }
    }

    private initCheckboxes = () => {
        this.checkboxRules = Array.from(this.element.querySelectorAll("ux-checkbox")).map((element) => {
            return {
                name: element.name,
                checked: element.checked,
                // @ts-expect-error Check for typing
                required: element.hasAttribute(requireAttr) ? element.getAttribute(requireAttr).split(",") : [],
                activated: []
            };
        });
    };

    componentDidLoad() {
        this.initCheckboxes();
    }

    render() {
        return (
            <Host
                class={{
                    [baseClass]: true
                }}
            >
                <slot />
            </Host>
        );
    }
}
